import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { MultipleProjectsCostEventsDataGrid } from "src/components/views/erp/project/project/MultipleProjectsCostEventsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/costEvents")({
	staticData: { title: i18n.t("cost_events"), legacyViewKey: "multipleProjectsCostEventsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MultipleProjectsCostEventsDataGrid />;
}
